import AboutSection from "../components/homepage/About";
import AppointmentSection from "../components/homepage/Appointment";
import BrandCarousel from "../components/homepage/Brand";
import GallerySection from "../components/homepage/Gallery";
import Hero from "../components/homepage/Hero";
import ProcessSection from "../components/homepage/Process";
import StatsSection from "../components/homepage/Stats";
import UpToDateSection from "../components/homepage/UpToDate";
import CallToAction from "../components/homepage/CallToAction";
function Home() {
  return (
    <>
      <Hero />
      <AboutSection />
      <ProcessSection />
      <AppointmentSection />
      {/* <GallerySection /> */}
      <StatsSection />
      <BrandCarousel />
      <UpToDateSection />
      <CallToAction />
    </>
  );
}

export default Home;
